import Dropdown from 'react-bootstrap/Dropdown'
import React, { ReactChild, ReactChildren } from 'react'
import DropdownToggle from './DropdownToggle'
import { IconOption } from '../Icon/icons'
import { S } from './NavDropdown'

interface NavDropdownProps {
    id: string
    text: string
    icon?: IconOption | string
    children: ReactChildren | ReactChild | ReactChild[]
    ToggleComponent?: typeof DropdownToggle
}

const NestedDropdown = ({ children, text, icon }: NavDropdownProps) => (
    <Dropdown drop="right">
        <Dropdown.Toggle
            as={DropdownToggle}
            text={text}
            icon={icon}
            direction="right"
        />

        <S.DropdownMenu>
            {children}
        </S.DropdownMenu>
    </Dropdown>
)

export default NestedDropdown
